import ApplicationController from "./application_controller";
import "../stylesheets/shares.css";

import { FetchRequest } from '@rails/request.js'

/* This is the custom StimulusReflex controller for the Posts Reflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  /*
   * Regular Stimulus lifecycle methods
   * Learn more at: https://stimulusjs.org/reference/lifecycle-callbacks
   *
   * If you intend to use this controller as a regular stimulus controller as well,
   * make sure any Stimulus lifecycle methods overridden in ApplicationController call super.
   *
   * Important:
   * By default, StimulusReflex overrides the -connect- method so make sure you
   * call super if you intend to do anything else when this controller connects.
   */

  static targets = ["form", "help", "urlpreview", "passwordfield", "tokenfield"];

  connect() {
    this.validateFormToken();
  }
  togglehelp(event) {
    this.helpTarget.classList.toggle("d-none");
  }
  async validateFormToken(event) {
    let pwd = this.tokenfieldTarget.value;
    if (pwd.length === 0) return;

    const response = await this.doFetch(
      "/shares/validate",
      "POST",
      JSON.stringify({
        authenticity_token: this.getCsrfToken(),
        remote: true,
        token: pwd,
        shareid: this.tokenfieldTarget.dataset.shareid,
      }),
    );
    if (response.ok) {
      let errors = await response.json();
      this.urlpreviewTarget.value = errors.urlpreview;

      if (errors.token && errors.token.length > 0) {
        document.getElementById("share-form-alerts").innerHTML =
          '<div class="alert alert-danger">' +
          errors.token.join("<br>") +
          "</div>";
        document.querySelector('input[type="submit"]').disabled = true;
      } else {
        document.getElementById("share-form-alerts").innerHTML = "";
        document.querySelector('input[type="submit"]').disabled = false;
      }
    }


    let score = this.calculateSecurityScore(pwd);
    this.create_strength_badge(this.tokenfieldTarget, "token-strength-badge", score);
  }

  createRandomShareToken(event) {
    const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789\-_";
    this.tokenfieldTarget.value = this.randomToken(charset, 8);
    this.validateFormToken(event);
  }

  createRandomPassword(event) {
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+";
    this.passwordfieldTarget.value = this.randomToken(charset, 8);
    this.validatePassword(event);
  }

  randomToken(charset, length = 8) {
    let password = "";
    for (let i = 0; i < 8; i++) {
      password += charset.charAt(Math.floor(Math.random() * charset.length));
    }
    return password;
  }

  async validatePassword(event) {
    let pwd = this.passwordfieldTarget.value;
    if (pwd.length === 0) return;

    let score = this.calculateSecurityScore(pwd);
    console.log("Password score: " + score + "/100");

    // Insert or update the badge after the password field
    this.create_strength_badge(this.passwordfieldTarget, "password-strength-badge", score);
  }
  create_strength_badge(targetElement, cssClassSelector, score) {
    // Determine badge color and label based on score
    let badgeColor, badgeLabel;
    if (score >= 80) {
      badgeColor = "success";
      badgeLabel = "Strong";
    } else if (score >= 50) {
      badgeColor = "warning";
      badgeLabel = "Moderate";
    } else {
      badgeColor = "danger";
      badgeLabel = "Weak";
    }

    let badge = targetElement.parentElement.querySelector(`.${cssClassSelector}`);
    console.log(`badge for ${cssClassSelector} : ${badge}`)
    if (!badge) {
      badge = document.createElement("span");
      badge.classList.add(cssClassSelector, "badge", "rounded-start-pill", "py-3", "ms-2");
      targetElement.insertAdjacentElement("afterend", badge);
    }
    badge.className = `${cssClassSelector} badge rounded-start-pill py-3 ms-2 bg-${badgeColor}`;
    badge.textContent = `${score}/100`;
  }
  calculateSecurityScore(pwd) {
    let score = 0;

    // Length scoring (max 30 points)
    if (pwd.length >= 8) score += 10;
    if (pwd.length >= 12) score += 10;
    if (pwd.length >= 16) score += 10;

    // Uppercase letters (max 15 points)
    if (/[A-Z]/.test(pwd)) score += 15;

    // Lowercase letters (max 15 points)
    if (/[a-z]/.test(pwd)) score += 15;

    // Numbers (max 15 points)
    if (/[0-9]/.test(pwd)) score += 15;

    // Special characters (max 25 points)
    if (/[!@#$%^&*()_+]/.test(pwd)) score += 25;

    return Math.min(score, 100);
  }
}
